// main.js - SoloOlio Shopify Theme (optimiert)

// Mouse detection for focus-visible styling
(function () {
  'use strict';
  document.body.addEventListener('mousedown', () => document.body.classList.add('using-mouse'));
  document.body.addEventListener('keydown', (e) => { if (e.key === 'Tab') document.body.classList.remove('using-mouse'); });
})();

// Mobile Menu
(function () {
  'use strict';

  const mobileBtn = document.getElementById('mobileMenuBtn');
  const nav = document.getElementById('nav');
  if (!mobileBtn || !nav) return;

  const closeMenu = () => {
    const wasActive = nav.classList.contains('active');
    nav.classList.remove('active');
    mobileBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (wasActive) mobileBtn.focus();
  };

  const openMenu = () => {
    mobileBtn.setAttribute('aria-expanded', 'true');
    nav.classList.add('active');
    document.body.style.overflow = 'hidden';
  };

  mobileBtn.addEventListener('click', () => {
    mobileBtn.getAttribute('aria-expanded') === 'true' ? closeMenu() : openMenu();
  });

  nav.querySelectorAll('.nav-link').forEach(link => link.addEventListener('click', closeMenu));

  document.addEventListener('click', (e) => {
    if (!mobileBtn.contains(e.target) && !nav.contains(e.target)) closeMenu();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && nav.classList.contains('active')) closeMenu();
  });
})();

// Cart Dropdown
(function () {
  'use strict';

  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDropdown = document.getElementById('cart-dropdown');
  const cartClose = document.querySelector('[data-cart-close]');
  if (!cartDropdown) return;

  const focusableSelectors = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';
  const getFocusable = () => Array.from(cartDropdown.querySelectorAll(focusableSelectors)).filter(el => el.offsetParent !== null);

  const openCart = (e) => {
    e.preventDefault();
    cartDropdown.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const focusable = getFocusable();
    (focusable[0] || cartDropdown).focus();
  };

  const closeCart = () => {
    const wasOpen = cartDropdown.getAttribute('aria-hidden') === 'false';
    cartDropdown.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (wasOpen && cartToggle) cartToggle.focus();
  };

  cartToggle?.addEventListener('click', openCart);
  cartClose?.addEventListener('click', closeCart);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && cartDropdown.getAttribute('aria-hidden') === 'false') closeCart();
  });

  cartDropdown.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || cartDropdown.getAttribute('aria-hidden') === 'true') return;
    const focusable = getFocusable();
    if (focusable.length === 0) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  cartDropdown.querySelector('[data-cart-overlay]')?.addEventListener('click', closeCart);
})();

// Form Validation
(function () {
  'use strict';

  document.querySelectorAll('form').forEach(form => {
    form.addEventListener('submit', (e) => {
      let isValid = true;
      form.querySelectorAll('[required]').forEach(field => {
        if (!field.value.trim()) {
          isValid = false;
          field.classList.add('is-error');
        } else {
          field.classList.remove('is-error');
        }
      });
      if (!isValid) e.preventDefault();
    });

    form.querySelectorAll('input, textarea').forEach(field => {
      field.addEventListener('input', () => field.classList.remove('is-error'));
    });
  });
})();

// Scroll-Reveal Animations
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.animate-on-scroll, .scroll-reveal, .slide-in-left, .slide-in-right').forEach(el => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const delay = parseFloat(entry.target.dataset.delay) || 0;
      if (delay > 0) {
        setTimeout(() => entry.target.classList.add('is-visible'), delay * 1000);
      } else {
        entry.target.classList.add('is-visible');
      }
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -50px 0px', threshold: 0.1 });

  function init() {
    document.querySelectorAll('.animate-on-scroll, .scroll-reveal, .slide-in-left, .slide-in-right').forEach(el => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

// Smooth Scroll for anchor links
(function () {
  'use strict';

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;
      const target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();
